import React from "react";
import { Button, Loader } from "@fluentui/react-northstar";
import * as axios from "axios";
import { useData } from "./useData";
import { Providers } from '@microsoft/mgt-react';

export const random = (min, max) =>
    Math.round(Math.random() * (max - min) + min);


export const loadAppsData = async (uid, allAppsHook, entitlementsHook) => {
    try {
        if (uid) {
            const resApps = await callFunction(false, "getAllApps?{0}");
            await allAppsHook(JSON.stringify(resApps));

            const res = await callFunction(true, "getUserApps?{0}");
            await entitlementsHook(JSON.stringify(res));
        }
    }
    catch (err) {
        throw err;
    }
}

export const loadReadinessData = async (uid, readinessDataHook) => {
    try {
        if (uid) {

            const res = await callFunction(false, "getReadinessContent?{0}");
            readinessDataHook(JSON.stringify(res));

        }
    }
    catch (err) {
        throw err;
    }
}

export async function getSettings() {
    const response = await fetch(`${getApiBaseUrl()}/getSettings`);
    return await response.json();
}

function getApiBaseUrl() {
    // In local CRA development we call the Functions host directly to avoid
    // relying on webpack proxy configuration or localhost resolution quirks.
    if (typeof window !== 'undefined' && window.location.port === '3000') {
        return 'http://127.0.0.1:7071/api';
    }
    return '/api';
}

export async function callFunction(useCredentials, functionName, params) {
    try {
        // Split off the function base name from query params, then strip the {0} placeholder.
        // The proxy adds the host key server-side - it never leaves the backend environment.
        const questionMark = functionName.indexOf('?');
        const fnBase   = questionMark >= 0 ? functionName.substring(0, questionMark) : functionName;
        const rawQuery = questionMark >= 0 ? functionName.substring(questionMark + 1) : '';
        const cleanQuery = rawQuery.replace('{0}', '').replace(/^&/, '');

        const proxyUrl = `${getApiBaseUrl()}/callProxy/${fnBase}${cleanQuery ? '?' + cleanQuery : ''}`;

        const headers = { 'Content-Type': 'application/json' };
        if (useCredentials) {
            const accessToken = await Providers.globalProvider.getAccessToken();
            headers['x-user-access-token'] = accessToken;
        }

        var response;
        if (params) {
            response = await axios.default.post(proxyUrl, params, { headers });
        } else {
            response = await axios.default.get(proxyUrl, { headers });
        }
        return response.data;
    } catch (err) {
        if (axios.default.isAxiosError(err)) {
            let funcErrorMsg = "";

            if (err?.response?.status === 404) {
                funcErrorMsg = `Azure Function not found`;
            } else if (err.message === "Network Error") {
                funcErrorMsg =
                    "Cannot call Azure Function due to network error, please check your network connection status and ";
                if (err.config?.url && err.config.url.indexOf("localhost") >= 0) {
                    funcErrorMsg += `make sure to start Azure Function locally first before running this App`;
                } else {
                    funcErrorMsg += `make sure to provision and deploy the Azure Function `;
                }
            } else {
                funcErrorMsg = err.message;
                if (err.response?.data?.error) {
                    funcErrorMsg += ": " + err.response.data.error;
                }
            }

            throw new Error(funcErrorMsg);
        }
        throw err;
    }
}

export function FunctionsCaller(props) {
    const { functionName, useCredentials, isVisual, callbackHook } = {
        functionName: "",
        useCredentials: true,
        ...props,
    };

    const { loading, data, error, reload } = useData(callFunction, {
        auto: false,
        useCredentials: useCredentials,
        functionName: functionName,
    });

    if (isVisual) {
        return (
            <div>
                <Button primary content="Call Azure Function" disabled={loading} onClick={reload} />
                {loading && (
                    <pre className="fixed">
                        {" "}
                        <Loader />{" "}
                    </pre>
                )}
                {!loading && !!data && !error && <pre className="fixed">{JSON.stringify(data, null, 2)}</pre>}
                {!loading && !data && !error && <pre className="fixed"></pre>}
                {!loading && !!error && <div className="error fixed">{error.toString()}</div>}
            </div>
        );
    }
    else {
        if (callbackHook) callbackHook(data);
    }
}

export async function loadContactData(users) {

    let contacts = [];
    let proms = [];
    users.forEach(element => {
        proms.push(GetUserDataFromGraph(element).then((value) => contacts.push(value)));
    });
    await Promise.allSettled(proms);
    return contacts;
}

export async function GetUserDataFromGraph(uid) {
    try {
        let provider = Providers.globalProvider;
        if (provider) {
            let graphClient = provider.graph.client;
            const profile = await graphClient.api("users/" + uid).get();
            return profile;
        }
    }
    catch (err) {
        throw err;
    }
}



